<style scoped>
.menu-mini {
  position: absolute !important;
  left: -15px;
  background-color: #ffffff !important;
  border: 1px solid rgb(218, 214, 214);
  top: 30px;
}
</style>

<template>
  <v-app>
    <SideMenu v-if="!isInsert" />
    <Loader ref="loader"></Loader>
    <v-main class="light">
      <v-card
        v-if="!isInsert"
        elevation="15"
        class="fill-height"
        :style="
          !this.$store.getters['Drawer/GET_MINI']
            ? 'z-index:300;right: 10px;'
            : 'z-index:300;right:0px'
        "
        shaped
      >
        <v-btn
          v-if="!this.$store.getters['Drawer/GET_MINI']"
          small
          icon
          @click.stop="set_mini()"
          class="menu-mini"
          style="z-index: 9999"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          v-if="this.$store.getters['Drawer/GET_MINI'] && singleMenu"
          small
          icon
          @click.stop="open_mini()"
          class="menu-mini"
          style="z-index: 9999"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <div class="pa-5">
          <router-view :key="$route.path"></router-view>
        </div>
      </v-card>
      <router-view v-if="isInsert" :key="$route.path"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import SideMenu from "./components/SideMenu";
import Loader from './components/Loader'
export default {
  name: "App",

  components: {
    SideMenu,
    Loader
  },

  data: () => ({
    isInsert: false,
    singleMenu: false,
  }),

  watch: {
    $route(to, from, where) {
      if (to.name == 'Dashboard') {
        //  this.singleMenu = false

      } else if (to.name == 'Qeue') {
        this.singleMenu = false
      } else {
        this.singleMenu = true
      }

      if (to.name == "AllForm") {
        this.isInsert = to.name == "AllForm";
      } else if (to.name == "SignIn") {
        this.isInsert = to.name == "SignIn";
      } else if (to.name == "add-newCustomer") {
        this.isInsert = to.name == "add-newCustomer";
      } else if (to.name == "register-newCustomer") {
        this.isInsert = to.name == "register-newCustomer";
      } else if (to.name == "FrontDashboard") {
        this.isInsert = to.name == "FrontDashboard";
      } else if (to.name == "Index") {
        this.isInsert = to.name == "Index";
      } else if (to.name == "DrillDown") {
        this.isInsert = to.name == "DrillDown";
      } else if (to.name == "LinktoLine") {
        this.isInsert = to.name == "LinktoLine";
      } else if (to.name == "linkReportDocument") {
        this.isInsert = to.name == "linkReportDocument";
      } else if (to.name == "SummaryMonth") {
        this.isInsert = to.name == "SummaryMonth";
      } else if (to.name == "Transfer-Waste") {
        this.isInsert = to.name == "Transfer-Waste";
      } else if (to.name == "qr-code") {
        this.isInsert = to.name == "qr-code";
      } else if (to.name == "LinkCustomer") {
        this.isInsert = to.name == "LinkCustomer";
      } else if (to.name == "bill-report-anamai") {
        this.isInsert = to.name == "bill-report-anamai";
      }else if (to.name == "waste-report-plublic-link") {
        this.isInsert = to.name == "waste-report-plublic-link";
      } else if (to.name == "by-month") {
        this.isInsert = to.name == "by-month";
      } else {
        this.isInsert = false;
      }


    },
  },
  mounted() {
    this.$token_api.interceptors.response.use((response) => {
      //console.log(response)
      return response

    }, (error) => {
      // console.log(error.response)
      if (error.response.status === 401) {
        this.$swal({
          title: "เซสชั่นหมดอายุ",
          icon: "warning",
          text: `กรุณาเข้าสู่ระบบใหม่อีกครั้ง`,
          timer: 3000
        }).then((result) => {
          if (result.value) {
            window.location.href = `${this.$global_link}/signin`;
            localStorage.clear()
          }
        })
        // router.push('/login')
      }
      return Promise.reject(error)
    });

    window.onpopstate = function () {
      window.location.reload()
    };
  },
  methods: {
    open_mini() {
      this.$store.commit("Drawer/SET_MINI_MENU", false);
    },
    set_mini() {
      this.$store.commit("Drawer/SET_MINI_MENU", true);
    },
  }

};
</script>
